<template>
  <div>
      <div :class="{'calendar-plugin': true,'show': show}" >
         <div class="calendar-nav">选择日期<span class="close" @click="closes" >×</span></div>
         <ul class="calendar-title">
            <li>日</li>
            <li>一</li>
            <li>二</li>
            <li>三</li>
            <li>四</li>
            <li>五</li>
            <li>六</li>
         </ul>
         <div class="calendar-content">
              <section class="calendar-item">
                  <div class="calendar-date">
                    <i class="icon i_back" @click="preMonth" ></i>
                    {{new_year}}年{{new_month}}月
                    <i class="icon i_next" @click="nextMonth" ></i>
                  </div>
                  <ul class="calendar-day">
                    <template v-for="(index) in FirstDayWeek()">
                        <li :key="index"></li>
                    </template>

                    <template v-for="(item,index) in dataFun()">
                        <template v-if="(formatDate(new Date(new_year + '/' + new_month + '/' + item), 'yyyyMMdd') * 1 ) == (formatDate(new Date(year + '/' + month + '/' + day), 'yyyyMMdd') * 1)">
                            <li :key="index + 'aqq'" class="active" @click="curDay(new_year, new_month, item)">
                                <div class="text">
                                <span class="date-elem">{{item}}</span>
                                </div>
                            </li>
                        </template>
                        <template v-else-if="(formatDate(new Date(new_year + '/' + new_month + '/' + item), 'yyyyMMdd') * 1 ) < (formatDate(new Date(start_time), 'yyyyMMdd') * 1)">
                            <li :key="index + 'aac'"  @click="curDay(new_year, new_month, item)">
                                <span class="date-elem">{{item}}</span>
                            </li>
                        </template>
                        <template v-else-if="(formatDate(new Date(new_year + '/' + new_month + '/' + item), 'yyyyMMdd') * 1 ) > (formatDate(new Date(end_time), 'yyyyMMdd') * 1)">
                             <li :key="index + 'acs'" class="disabled">
                                <span class="date-elem">{{item}}</span>
                            </li>
                        </template>
                        <template v-else>
                            <template v-if="(formatDate(new Date(new_year + '/' + new_month + '/' + item), 'yyyyMMdd') * 1 ) > futureToday()">
                                 <li :key="index + 'ac'" class="no">
                                    <div class="text">
                                        <span class="date-elem">{{item}}</span>
                                        <span class="name-elem">暂无</span>
                                    </div>
                                </li>
                            </template>
                            <template v-else>
                                <li :key="index + 'a'"  @click="curDay(new_year, new_month, item)">
                                    <span class="date-elem">{{item}}</span>
                                </li>
                            </template>
                        </template>
                    </template>
                  </ul>
              </section>
         </div>
      </div>
  </div>
</template>

<script>
export default {
    name: "calendar",
    props: ["show", "start_time", "end_time", "current_time"],
    data () {
        return {
            newDate: new Date(),
            year: this.formatDate(this.newDate, 'yyyy'),
            month: parseInt(this.formatDate(this.newDate, 'MM')),
            day: parseInt(this.formatDate(this.newDate, 'dd')),

            new_year: this.formatDate(this.newDate, 'yyyy'),
            new_month: parseInt(this.formatDate(this.newDate, 'MM')),
            new_day: parseInt(this.formatDate(this.newDate, 'dd'))
        }
    },
    watch: {
        show () {
            this.inIntDate()
        }
    },
    mounted () {
        this.inIntDate()
    },
    computed: {
    },
    methods: {
        getDays () {
            return new Date(this.new_year, this.new_month, 0).getDate()
        },
        FirstDayWeek () {
            const dat = []
            for (var m = 0; m < new Date(this.new_year + "/" + this.new_month + "/1").getDay(); m++) {
                dat[m] = m;
            }
            return dat
        },
        futureToday () {
            const futureoday = new Date();
            futureoday.setDate(futureoday.getDate() + 1);
            return this.formatDate(futureoday, 'yyyyMMdd') * 1;
        },
        closes () {
            // this.$parent.closeCalendar()
            this.$emit('update:show', false)
        },
        nextMonth () {
            let newMonth = parseInt(this.new_month) + 1;
            if (newMonth > 12) {
                this.new_year++;
                newMonth = 1;
            }
            this.new_month = newMonth
        },
        preMonth () {
            let newMonth = parseInt(this.new_month) - 1;
            if (newMonth < 1) {
                this.new_year--;
                newMonth = 12;
            }
            this.new_month = newMonth
        },
        curDay (newyear, newmonth, newday) {
            this.year = newyear
            this.month = newmonth
            this.day = newday
            this.$emit("callback", newyear, newmonth, newday)
        },
        dataFun () {
            const data = []
            for (var m = 0; m < this.getDays(); m++) {
                data[m] = (m + 1);
            }
            return data
        },
        inIntDate () {
            const newDate = new Date(this.current_time.replace(/-/g, "/"));
            this.year = this.formatDate(newDate, 'yyyy')
            this.month = parseInt(this.formatDate(newDate, 'MM'))
            this.day = parseInt(this.formatDate(newDate, 'dd'))

            this.new_year = this.formatDate(newDate, 'yyyy')
            this.new_month = parseInt(this.formatDate(newDate, 'MM'))
            this.new_day = parseInt(this.formatDate(newDate, 'dd'))
        },
        formatDate (date, fmt, flag) {
        /**
             * 对Date的扩展，将 Date 转化为指定格式的String
             * 月(M)、日(d)、12小时(h)、24小时(H)、分(m)、秒(s)、周(E)、季度(q) 可以用 1-2 个占位符
             * 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
             * eg:
             * this.formatDate(new Date(),'yyyy-MM-dd') ==> 2014-03-02
             * this.formatDate(new Date(),'yyyy-MM-dd hh:mm') ==> 2014-03-02 05:04
             * this.formatDate(new Date(),'yyyy-MM-dd HH:mm') ==> 2014-03-02 17:04
             * this.formatDate(new Date(),'yyyy-MM-dd hh:mm:ss.S') ==> 2006-07-02 08:09:04.423
             * this.formatDate(new Date(),'yyyy-MM-dd E HH:mm:ss') ==> 2009-03-10 二 20:09:04
             * this.formatDate(new Date(),'yyyy-MM-dd EE hh:mm:ss') ==> 2009-03-10 周二 08:09:04
             * this.formatDate(new Date(),'yyyy-MM-dd EEE hh:mm:ss') ==> 2009-03-10 星期二 08:09:04
             * this.formatDate(new Date(),'yyyy-M-d h:m:s.S') ==> 2006-7-2 8:9:4.18
         */
            if (!date) {
                return;
            }
            var o = {
                "M+": date.getMonth() + 1, // 月份
                "d+": date.getDate(), // 日
                // eslint-disable-next-line eqeqeq
                "h+": flag ? date.getHours() : (date.getHours() % 12 == 0 ? 12 : date.getHours() % 12), // 小时
                "H+": date.getHours(), // 小时
                "m+": date.getMinutes(), // 分
                "s+": date.getSeconds(), // 秒
                "q+": Math.floor((date.getMonth() + 3) / 3), // 季度
                S: date.getMilliseconds() // 毫秒
            };
            var week = {
                0: "日",
                1: "一",
                2: "二",
                3: "三",
                4: "四",
                5: "五",
                6: "六"
            };
            if (/(y+)/.test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
            }

            if (/(E+)/.test(fmt)) {
                fmt = fmt.replace(RegExp.$1, ((RegExp.$1.length > 1) ? (RegExp.$1.length > 2 ? "星期" : "周") : "") + week[date.getDay() + ""]);
            }
            for (var k in o) {
                if (new RegExp("(" + k + ")").test(fmt)) {
                    // eslint-disable-next-line eqeqeq
                    fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
                }
            }
            return fmt;
        }
    }
}
</script>
